import React, { useEffect } from "react";

//https://www.youtube.com/watch?v=Y0-qdp-XBJg
//https://scotch.io/courses/using-react-router-4/authentication-with-redirect

export default function FU(props) {
  // Declare a new state variable, which we'll call "count"
  //const [count, setCount] = useState(0);
  //const { history } = this.props;
  //lifecycle methods

  useEffect(() => {
    //componentDidMount || componentDidUpdate
    console.log("use effect executed! " + props.location.state.siteId);
  });

  useEffect(() => {
    //componentWillUnmount
    console.log("use effect executed!");
  }, []);

  const submitlogin = e => {
    alert("submited successfully !");
    //e.preventDefault();
    console.log("submitted form to log in ");
    //ReactDOM.render(<Loged />, document.getElementById("root"));
  };

  /*<div>
<p>You clicked {count} times</p>
<button onClick={() => setCount(count + 1)}>Click me</button>
</div> */
  return (
    <React.Fragment>
      Firmware Upgrade Page {props.location.state.siteId}
    </React.Fragment>
  );
}
